import { commonTypes } from './common';
import { PRODUCT_TYPES } from '../utils/catalog';
import { CQ_ACTION_CODES } from '../catalogConstants';

export const initialState = {
  accountInfo: null,
  addressInfo: null,
  installationAddress: null,
  nonFiberCoverage: false,
  permanentResidenceInfo: null,
  personalDataInfo: null,
  tvMailAdded: null,
  choices: null,
};

export const types = {
  SET_TV_MAIL_ADDED: 'SUMMARY/SET_TV_MAIL_ADDED',
  SET_CHOICES: 'SUMMARY/SET_CHOICES',
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const SummaryInfoReducer = (
  state = JSON.parse(JSON.stringify(initialState)),
  action,
) => {
  switch (action.type) {
    case commonTypes.RESET_FLOW: {
      return {
        ...state,
        addressInfo: null,
        accountInfo: null,
      };
    }
    case commonTypes.SET_NON_FIBER_COVERAGE: {
      const { nonFiberCoverage } = action.payload;

      return {
        ...state,
        nonFiberCoverage,
      };
    }
    case commonTypes.SET_AFTER_SALE_PARENT_PRODUCT: {
      const { afterSaleParentProduct } = action.payload;

      const newState = {
        ...state,
      };

      if (afterSaleParentProduct && afterSaleParentProduct.address) {
        newState.installationAddress = afterSaleParentProduct.address;
      }

      return newState;
    }
    case commonTypes.SET_INSTALLATION_ADDRESS: {
      const { installationAddress } = action.payload;

      if (installationAddress.fullAddress) {
        return {
          ...state,
          installationAddress: installationAddress.fullAddress,
        };
      }

      return {
        ...state,
      };
    }
    case commonTypes.SET_INSTALLATION_ADDRESS_NAME: {
      const { address } = action.payload;

      if (address) {
        return {
          ...state,
          installationAddress: address,
        };
      }
    }
    case commonTypes.SET_CLIENT_INFO: {
      const {
        name,
        fullName,
        docNumber,
        contactEmail,
        contactPhone,
        contactAddress,
        companyName,
        docTypeText,
      } = action.payload;
      return {
        ...state,
        personalDataInfo: {
          name,
          fullName: companyName || fullName,
          isCompany: !!companyName,
          docType: docTypeText,
          docNumber,
          contactAddress: {
            id: contactAddress.contactId,
            address: contactAddress.value,
          },
          contactPhone: contactPhone.value,
          email: contactEmail.value,
        },
        permanentResidenceInfo: {
          id: contactAddress.contactId,
          address: contactAddress.value,
        },
      };
    }
    case commonTypes.SET_PERSONAL_CONTACT_INFO: {
      const { contactPhone, email } = action.payload;
      let newPersonalDataInfo = { ...state.personalDataInfo };

      if (newPersonalDataInfo) {
        newPersonalDataInfo.contactPhone = contactPhone;
        newPersonalDataInfo.email = email;
      } else {
        newPersonalDataInfo = {
          contactPhone,
          email,
        };
      }

      return {
        ...state,
        personalDataInfo: newPersonalDataInfo,
      };
    }
    case types.SET_CHOICES: {
      const { choices } = action.payload;
      if (!state.choices) {
        return {
          ...state,
          choices,
        };
      }
      const newChoices = JSON.parse(JSON.stringify(state.choices));
      Object.keys(choices).forEach((key) => {
        if (newChoices[key]) {
          const choicesToAdd = [];
          choices[key].forEach((choiceToAdd)=>{
            const alreadyExists = newChoices[key].find(
              (choice) =>
                choice.actionId === choiceToAdd.actionId &&
                (choice.actionId === CQ_ACTION_CODES.MIGRATION ||
                  choice.actionId === CQ_ACTION_CODES.KEEP) &&
                  choice.phoneNumber === choiceToAdd.phoneNumber
            );
            if(!alreadyExists){
              choicesToAdd.push(choiceToAdd);
            }
          })
          newChoices[key] = [...newChoices[key], ...choicesToAdd];
        } else {
          newChoices[key] = choices[key];
        }
      });
      return {
        ...state,
        choices: newChoices,
      };
    }
    case commonTypes.SET_SELECT_ELEMENTS_NEEDS: {
      const { mainOptionSelected, secondaryOptionsForUI } = action.payload;

      let newChoices = JSON.parse(JSON.stringify(state.choices));

      if (mainOptionSelected
        && secondaryOptionsForUI
        && secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE]
        && secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
        && secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected].choiceGroups
        && Array.isArray(secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected].choiceGroups)
        && secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected].choiceGroups.length === 1
      ) {
        const landLineChoice = secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected].choiceGroups[0];
        if (landLineChoice && landLineChoice.customerQuoteItems && Array.isArray(landLineChoice.customerQuoteItems) && landLineChoice.customerQuoteItems.length === 1 && landLineChoice.customerQuoteItems[0].phoneOptions && landLineChoice.customerQuoteItems[0].phoneOptions.length === 1) {
          const customerQuoteItem = landLineChoice.customerQuoteItems[0];
          let landLinePhoneNumber;
          if (customerQuoteItem.phoneOptions && Array.isArray(customerQuoteItem.phoneOptions) && customerQuoteItem.phoneOptions.length === 1 && customerQuoteItem.phoneOptions[0].value) {
            landLinePhoneNumber = customerQuoteItem.phoneOptions[0].value;
          }
          const newItem = {
            actionId: customerQuoteItem.actionId,
            phoneNumber: landLinePhoneNumber,
            description: customerQuoteItem.description,
          };
          if (newChoices) {
            if (newChoices[PRODUCT_TYPES.LAND_LINE]) {
              newChoices[PRODUCT_TYPES.LAND_LINE] = [...newChoices[PRODUCT_TYPES.LAND_LINE], newItem];
            } else {
              newChoices[PRODUCT_TYPES.LAND_LINE] = [newItem];
            }
          } else {
            newChoices = {
              [PRODUCT_TYPES.LAND_LINE]: [newItem],
            };
          }
        }
      }

      if (mainOptionSelected
        && secondaryOptionsForUI
        && secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE]
        && secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
        && secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected].keepGroups
        && Array.isArray(secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected].keepGroups)
        && secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected].keepGroups.length === 1
      ) {
        const landLineChoice = secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected].keepGroups[0];
        if (landLineChoice && landLineChoice.customerQuoteItems && Array.isArray(landLineChoice.customerQuoteItems)  && landLineChoice.customerQuoteItems.length === 1 && landLineChoice.customerQuoteItems[0].phoneOptions && landLineChoice.customerQuoteItems[0].phoneOptions.length === 1) {
          const customerQuoteItem = landLineChoice.customerQuoteItems[0];
          let landLinePhoneNumber;
          if (customerQuoteItem.phoneOptions && Array.isArray(customerQuoteItem.phoneOptions) && customerQuoteItem.phoneOptions.length === 1 && customerQuoteItem.phoneOptions[0].value) {
            landLinePhoneNumber = customerQuoteItem.phoneOptions[0].value;
          }
          const newItem = {
            actionId: customerQuoteItem.actionId,
            phoneNumber: landLinePhoneNumber,
            description: customerQuoteItem.description,
          };
          if (newChoices) {
            if (newChoices[PRODUCT_TYPES.LAND_LINE]) {
              newChoices[PRODUCT_TYPES.LAND_LINE] = [...newChoices[PRODUCT_TYPES.LAND_LINE], newItem];
            } else {
              newChoices[PRODUCT_TYPES.LAND_LINE] = [newItem];
            }
          } else {
            newChoices = {
              [PRODUCT_TYPES.LAND_LINE]: [newItem],
            };
          }
        }
      }

      if (
        mainOptionSelected
        && secondaryOptionsForUI
        && secondaryOptionsForUI[PRODUCT_TYPES.MOBILE]
        && secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected]
        && secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected]
          .keepGroups
        && Array.isArray(
          secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected]
            .keepGroups,
        )
        && secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected]
          .keepGroups.length > 0
      ) {
        const keepChoices = secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected].keepGroups;
        keepChoices.forEach((choice) => {
          if (choice && choice.customerQuoteItems && Array.isArray(choice.customerQuoteItems) && choice.customerQuoteItems.length === 1 && choice.customerQuoteItems[0].phoneOptions && choice.customerQuoteItems[0].phoneOptions.length === 1) {
            choice.customerQuoteItems.forEach((item) => {
              const newItem = {
                actionId: item.actionId,
                description: item.description,
                phoneNumber: item.phoneOptions[0].value,
              };
              if (newChoices) {
                if (newChoices[PRODUCT_TYPES.MOBILE]) {
                  newChoices[PRODUCT_TYPES.MOBILE] = [...newChoices[PRODUCT_TYPES.MOBILE], newItem];
                } else {
                  newChoices[PRODUCT_TYPES.MOBILE] = [newItem];
                }
              } else {
                newChoices = {
                  [PRODUCT_TYPES.MOBILE]: [newItem],
                };
              }
            });
          }
        });
      }
      if (newChoices) {
        return {
          ...state,
          choices: newChoices,
        };
      }
      return {
        ...state,
      };
    }
    case commonTypes.SET_ADDRESS_INFO: {
      const { fullAddress } = action.payload;
      return {
        ...state,
        addressInfo: fullAddress,
      };
    }
    case commonTypes.SET_SHIPPING_ADDRESS_NAME: {
      const { address } = action.payload;
      return {
        ...state,
        addressInfo: address,
      };
    }
    case commonTypes.SET_PERMANENT_RESIDENCE_INFO: {
      const { locationId, fullAddress } = action.payload;
      return {
        ...state,
        permanentResidenceInfo: {
          id: locationId,
          address: fullAddress,
        },
      };
    }
    case commonTypes.SET_PERMANENT_RESIDENCE_ADDRESS_NAME: {
      const { address } = action.payload;
      return {
        ...state,
        permanentResidenceInfo: {
          ...state.permanentResidenceInfo,
          address,
        },
      };
    }
    case commonTypes.SET_ACCOUNT_INFO: {
      const { customerAccountNumber } = action.payload;

      if (customerAccountNumber) {
        return {
          ...state,
          accountInfo: [
            {
              customerAccountNumber,
            },
          ],
        };
      }

      return { ...state };
    }
    case types.SET_TV_MAIL_ADDED: {
      const { tvMailAdded } = action.payload;
      return {
        ...state,
        tvMailAdded,
      };
    }
    case commonTypes.SET_PPIP_SELECTED: {
      const { ppipSelected } = action.payload;
      return {
        ...state,
        ppipRequired: ppipSelected,
      };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  setTvMailAdded: tvMailAdded => ({
    type: types.SET_TV_MAIL_ADDED,
    payload: {
      tvMailAdded,
    },
  }),
  setChoices: choices => ({
    type: types.SET_CHOICES,
    payload: {
      choices,
    },
  }),
};

export default SummaryInfoReducer;
